import { render, staticRenderFns } from "./StatsCardV4.vue?vue&type=template&id=911f82c0&"
import script from "./StatsCardV4.vue?vue&type=script&lang=js&"
export * from "./StatsCardV4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatsCardV4.vue"
export default component.exports